import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import RetinaImage from 'react-retina-image'

class Header extends Component {

    state = {
        linkDisabled: this.props.linkDisabled ? this.props.linkDisabled : '',
        goBack: this.props.goBack ? this.props.goBack : ''
    }

    componentDidUpdate = () => {
        if (this.props.linkDisabled && this.state.linkDisabled !== this.props.linkDisabled) {
            this.setState({
                linkDisabled: this.props.linkDisabled
            })

        }
        if (this.props.goBack && this.state.linkDisabled !== this.props.linkDisabled) {
            this.setState({
                goBack: this.props.goBack,
                linkDisabled: this.props.linkDisabled
            })

        }

    }
    goToHome = () => {
        //console.log('goToHome')
        window.location = '/'
    }

    render() {
        return (
            <div className="onboarding-header">
                {this.state.linkDisabled ?

                    <RetinaImage src={['/img/emitto-logo.png', '/img/emitto-logo.svg']} checkIfRetinaImgExists={false}/>
                    //<img src="/img/small-logo.png" alt="emitto"/>
                    :
                    this.state.goBack ?

                        <Link to={this.state.goBack}>
                            <RetinaImage src={['/img/emitto-logo.png', '/img/emitto-logo.svg']}
                                         checkIfRetinaImgExists={false}/>
                        </Link>
                        :
                        <div className='cursor-pointer' onClick={this.goToHome}>
                            <RetinaImage src={['/img/emitto-logo.png', '/img/emitto-logo.svg']}
                                         checkIfRetinaImgExists={false}/>
                        </div>
                }
            </div>

        )
    }
}

export default Header;